import { useContext } from "react";
import { Box, Typography } from "@material-ui/core";
import { CancelacionMasivaContext } from "../../../../../context";
import { SuccessTablePolizas } from "../successTablePolizas";
import { FailedTablePolizas } from "../failedTablePolizas";

export const ResultTableCancelacion = () => {
  const { polizasCanceladas, polizasConError } = useContext(
    CancelacionMasivaContext
  );

  const hayCanceladas = Boolean(polizasCanceladas?.length);
  const hayErrores = Boolean(polizasConError?.length);

  /* el orden lo fija el mockup de la HU8: primero los errores y debajo las
     polizas a cancelar, igual que ResultTable de altaRiesgo16 */
  return (
    <>
      {hayErrores && <FailedTablePolizas rows={polizasConError} />}

      {hayCanceladas ? (
        <SuccessTablePolizas rows={polizasCanceladas} />
      ) : (
        <Box>
          <Typography variant="h6" color="primary">
            Ninguna de las pólizas del archivo puede cancelarse
          </Typography>
        </Box>
      )}
    </>
  );
};
